import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as minutesPackageApi from "../../../api/minutesPackage";

export function usePackages() {
  return useQuery({
    queryKey: ["packages"],
    queryFn: () => minutesPackageApi.fetchAll(),
  });
}

export function useSavePackage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => minutesPackageApi.saveOrUpdate(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["packages"] }),
  });
}

export function useArchivePackage() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => minutesPackageApi.archive(null, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["packages"] }),
  });
}
